// @flow
import React, { Component } from 'react'
import postJson from '../../services/postJson'
import _ from 'lodash'
import SingleParamPopup from '../CampaignsTable/SingleParamPopup'

type Props = {|
  value: string,
  id: string,
  onChange: (string) => void
|}

type State = {|
  value: string,
  isOpen: boolean,
  errors: Array<string>
|}

export default class NamePopup extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      value: props.value,
      isOpen: false,
      errors: []
    }
  }

  render() {
    return (
      <SingleParamPopup
        isOpen={this.state.isOpen}
        value={this.state.value}
        errors={this.state.errors}
        triggerBlock={this.renderTriggerBlock()}
        onChange={(e) => this.setState({ value: e.target.value })}
        onDropdownChange={(isOpen) => this.dropdownChanged(isOpen)}
        onSubmit={() => this.submit()}
      />
    )
  }

  componentDidUpdate(prevProps: Props) {
    if (!_.isEqual(prevProps.value, this.props.value)) {
      this.setState({ value: this.props.value })
    }
  }

  dropdownChanged(isOpen: boolean) {
    if (!isOpen) this.setState({ value: this.props.value })
    this.setState({ isOpen })
  }

  submit() {
    const { value } = this.state
    const { id, onChange } = this.props
    const updateUrl = `/api/v1/agencies/ad_accounts/${id}`
    postJson(updateUrl, { data: { name: value } })
      .done((response) => {
        onChange(response.data.name)
        this.setState({ isOpen: false })
      })
      .fail((e: any) => {
        if (e.status === 422) {
          this.setState({ errors: e.responseJSON.message.name })
        } else {
          this.setState({ errors: [`${e.status} Server error`] })
        }
      })
  }

  renderTriggerBlock() {
    return (
      <i
        className="glyphicon glyphicon-pencil t-NamePopupTrigger"
        onClick={(event) => event.preventDefault()}
      />
    )
  }
}
